import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from 'axios';
import VueAxios from 'vue-axios';
import Notifications from 'vue-notification';
import VModal from 'vue-js-modal'
import MomentJs from 'moment';


/*
| ---------------------------------------------------------------
|  Modules 
| ---------------------------------------------------------------
*/
Vue.use(VModal);
Vue.use(Notifications);
Vue.prototype.$moment = MomentJs;

/*
| ---------------------------------------------------------------
|  Axios 
| ---------------------------------------------------------------
*/
const baseURL = "https://www.api.navinem.dk/api/student";
Vue.use(VueAxios, axios);
Vue.axios.defaults.baseURL = baseURL;
Vue.axios.interceptors.response.use(function (response) {
  // Do something globally on request success
  return response;
}, function(error) {
  // Do something globally on request error
  if(error.response.status >= 500) {
    alert('Der er sket en uventet fejl. Din request kunne ikke behandles. Du kan forsøge at genindlæse siden ved at trykke F5 og derefter prøve igen.');
  }
  return Promise.reject(error);
});

/*
| ---------------------------------------------------------------
|  Vue Router 
| ---------------------------------------------------------------
*/
Vue.router = router;


/*
| ---------------------------------------------------------------
|  Auth 
| ---------------------------------------------------------------
*/
Vue.use(require('@websanova/vue-auth'), {
  auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js')
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
